module.exports = __webpack_public_path__ + "static/media/waiter.8a4f8da2.svg";